/* Makes hero slideshow banners clickable, if they have a link set,
   without wrapping the image in an <a> tag (which was interfering
   with the theme's lazyload script and causing a flicker). */
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    var slide = e.target.closest('[data-slide-link]');
    if (!slide) return;
    // don't hijack clicks on a real button/link already inside the slide
    if (e.target.closest('a, button')) return;
    var url = slide.getAttribute('data-slide-link');
    if (url) window.location.href = url;
  });

  document.querySelectorAll('[data-slide-link]').forEach(function (slide) {
    slide.style.cursor = 'pointer';
  });
});
